import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Check, Eye, Link as LinkFeather, RefreshCw, Search, X } from 'react-feather';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { DropdownItem } from 'reactstrap';
import AuthenticateChildren from '../../AuthenticateChildren';
import AuthService from '../../AuthService';
import { AddButton } from '../../components/AddButton';
import { FeatherButton } from '../../components/FeatherButton';
import { Loader } from '../../components/Loader';
import OptionsButton from '../../components/OptionsButton';
import { PTInputText } from '../../components/PTElements';
import { history } from '../../configureStore';
import { activePatientSyncMonths, initialSync_Status, roles } from '../../constants';
import { EVO } from '../../EVO';
import * as actions from "../../redux/clients";

const Clients = props => {
    const [clients, setClients] = useState([]);

    useEffect(() => {
        props.fetchclients(props);
    }, []);

    useEffect(() => {
        setClients(props.clients);
    }, [props.clients]);

    const setAsClient = client => {
        AuthService.getInstance().setAsClient(client);
        history.go();
    }

    const runSyncAllToCM = (skipCliniko) => {
        if (window.confirm('Are you sure you want to sync this client? It is a long running background process')) {
            props.runSyncAllToCM(skipCliniko);
        }
    };

    const redirect = () => {
        if (props.redirect) {
            return <Redirect to={props.redirect} />;
        }
    }

    

    const query = (e) => {
        let query = e.query;
        if (!query) {
            setClients(props.clients);
            return;
        }

        query = query.toLowerCase().replace(/[^a-z0-9]/g, '');
        const searchProp = (val) => {
            if (!val) return false;
            var actualVal = val.toLowerCase().replace(/[^a-z0-9]/g, '');
            return actualVal.indexOf(query) > -1;
        };

        var filtered = props.clients.filter(c => searchProp(c.name) || searchProp(c.ownerName) || searchProp(c.emailAddress) || searchProp(c.receptionEmailAddress) || searchProp(c.cmClientId) || searchProp(c.id) || searchProp(c.shortName));
        setClients(filtered);
    };

    let timeout = 0;
    const queryChange = (submitForm) => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
            submitForm();
        }, 500);
    };

    const renderTable = () => {
        return <div>
            <AuthenticateChildren roles={[roles.Admin, roles.Owner]}>
                <AddButton to={`/clients/new`} />
            </AuthenticateChildren>
            <AuthenticateChildren roles={[roles.Admin]}>
                <Formik
                    initialValues={initialQuery}
                    onSubmit={query}>
                    {({ submitForm }) =>
                        <Form>
                            <div className="client-query-wrapper">
                                <Field name="query" type="text" component={PTInputText} placeholder="Search.." inline='true' left='true' onChange={() => queryChange(submitForm)} />
                                <FeatherButton feather={<Search />} type="submit" />
                                </div>
                        </Form>
                    }
                </Formik>
            </AuthenticateChildren>
            <table className='table table-striped'>
                <thead>
                    <tr>
                        <th>Name</th>
                        <AuthenticateChildren roles={[roles.Admin]}>
                            <th className="centered">Onboarded</th>
                            <th className="centered">Suspended</th>
                            <th className="centered">Sync Status</th>
                            <th className="centered">Active Patients</th>
                            <th className="centered">Active Months</th>
                            <th className="centered">Has Transactional</th>
                        </AuthenticateChildren>
                        <th></th>
                        <AuthenticateChildren roles={[roles.Admin]}>
                            <th></th>
                        </AuthenticateChildren>
                    </tr>
                </thead>
                <tbody>
                    {!EVO.any(clients) ? null : clients.map(client =>
                        <tr key={client.id}>
                            <td>{client.name}</td>
                            <AuthenticateChildren roles={[roles.Admin]}>
                                <td className="centered"><TickCross bool={client.onboarded} /></td>
                                <td className="centered"><TickCross bool={client.suspended} /></td>
                                <td className="centered">
                                    <div className={`sync-status-${client.initialSyncStatus}`}>
                                        <span>{EVO.getPropertyNameFromValue(initialSync_Status, client.initialSyncStatus)}</span>
                                    </div>
                                </td>
                                <td className="centered">{EVO.canBeZero(client.activePatients) ? client.activePatients : "-"}</td>
                                <td className="centered"><span>{EVO.getPropertyNameFromListValue(activePatientSyncMonths, client.activePatientSyncMonths)}</span></td>
                                <td className="centered"><TickCross bool={client.hasTransactional} /></td>
                            </AuthenticateChildren>
                            <td><Link to={`/clients/${client.id}`}><LinkFeather>Edit</LinkFeather></Link></td>
                            <AuthenticateChildren roles={[roles.Admin]}>
                                <td><FeatherButton feather={<Eye />} onClick={() => setAsClient(client)}></FeatherButton></td>
                            </AuthenticateChildren>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    }

    return (
        <div>
            <h1>Clients</h1>
            {redirect()}
            <Loader loading={props.loading}>
                <AuthenticateChildren roles={[roles.Admin]}>
                    <OptionsButton>
                        <DropdownItem onClick={() => runSyncAllToCM(true)}><RefreshCw /> Resync ALL (CM ONLY)</DropdownItem>
                        <DropdownItem onClick={() => runSyncAllToCM(false)}><RefreshCw /> Resync ALL (Cliniko AND CM)</DropdownItem>
                    </OptionsButton>
                </AuthenticateChildren>
                {renderTable()}
            </Loader>
        </div>
    );
};

const TickCross = ({ bool }) => bool ? <Check color="green" /> : <X color="red" />;

const initialQuery = {
    query: ''
};

const mapStateToProps = ({ clients, user }) => ({
    clients: clients.clients,
    loading: clients.loading,
    error: clients.error,
    redirect: clients.redirect,
    asClientId: user.asClientId,
    asClientName: user.asClientName
});

export default connect(mapStateToProps, actions)(withRouter(Clients));


// WEBPACK FOOTER //
// ./src/pages/Clients/Clients.js